import React, { useEffect } from 'react';

import CommonImage from '@components/CommonImage';
import CustomDropdown from '@components/CustomDropdown';

import { INITIAL_FOLDER_STATE } from '@features/favourites/utils/favouriteUtil';
import useCreateFolder from '@features/favourites/hooks/useCreateFolder';

const AddNewFolder = ({ onCloseModal, selectedFolderToEdit, handleSuccess, isEdit }) => {
	const { selectedValue, setSelectedValue, brands, errors, handleSubmit } =
		useCreateFolder(INITIAL_FOLDER_STATE);

	useEffect(() => {
		setSelectedValue({
			folderName: selectedFolderToEdit?.name,
			brand: { ...selectedFolderToEdit?.brandResponse },
			folderId: selectedFolderToEdit?.id
		});
	}, [selectedFolderToEdit?.id]);

	const handleCancel = () => {
		onCloseModal();
		setSelectedValue(INITIAL_FOLDER_STATE);
	};

	const resetForm = () => {
		setSelectedValue(INITIAL_FOLDER_STATE);
		onCloseModal();
	};

	const onSubmit = async () => {
		await handleSubmit(resetForm, isEdit, false);
		handleSuccess && handleSuccess();
	};

	return (
		<div className="popup-wrapper">
			<div className="common-popup sample-location-modal create-folder-modal">
				<div className="common-popup-header d-flex justify-content-between border-0">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Create folder</h3>
					</div>
					<div className="close-btn" onClick={onCloseModal}>
						<CommonImage src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body py-0">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Folder</label>
									<input
										type="text"
										name="folderName"
										id="folderName"
										value={selectedValue.folderName}
										onChange={(e) =>
											setSelectedValue({ ...selectedValue, folderName: e.target.value })
										}
									/>
									{errors?.folderName && <p className="error">{errors.folderName}</p>}
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Brand</label>
									<CustomDropdown
										title="Select Brand"
										items={brands}
										selectedItem={selectedValue?.brand?.name}
										onItemClick={(value) =>
											setSelectedValue({ ...selectedValue, brand: value })
										}
									/>
									{errors?.brand && <p className="error">{errors.brand}</p>}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={handleCancel}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={onSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddNewFolder;
